import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {FormBuilder, FormControl, ValidationErrors, Validators} from '@angular/forms';
import {UsersInsuranceService} from '../../services/usersinsurance/users.insurance.service';
import {UsersService} from '../../services/users/users.service';
import {MatTabGroup} from '@angular/material/tabs';
import {UiAlertService} from '../../services/ui-alert/ui-alert.service';
import {ToastComponent} from '../toast/toast.component';
import {UtilsService} from '../../services/utils/utils.service';

@Component({
  selector: 'app-insurance-dependents',
  templateUrl: './insurance-dependents.component.html',
  styleUrls: ['./insurance-dependents.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InsuranceDependentsComponent implements OnInit, AfterViewInit {

  @Input() vendorProduct;
  @Output() formEvent: EventEmitter <any> = new EventEmitter<any>();

  // @ts-ignore
  @ViewChild('tabs') tabGroup: MatTabGroup;

  public dependents = [];
  public addTabName = 'Add Dependent';
  private counter = 1;
  public selectedTabIndex = 0;
  public saving = false;
  protected hasPrimary;
  protected currentDependent;
  protected getTel;

  constructor(
      private formBuilder: FormBuilder,
      private usersInsuranceService: UsersInsuranceService,
      private usersService: UsersService,
      private uiAlertService: UiAlertService,
      private toastComponent: ToastComponent,
      private utilsService: UtilsService
  ) {
  }

  buildForm(dependent: any): void {
    dependent.form = this.formBuilder.group({
      gender: new FormControl(dependent.gender, Validators.required),
      tobaccoUseDate: new FormControl(dependent.tobaccoUseDate),
      relationship: new FormControl(dependent.relationship, Validators.required),
      firstName: new FormControl(dependent.firstName, Validators.required),
      lastName: new FormControl(dependent.lastName, Validators.required),
      dob: new FormControl(dependent.dob, Validators.required),
      ssn: new FormControl(dependent.ssn),
      email: new FormControl(dependent.email),
      phone: new FormControl(dependent.phone),
    });
    dependent.form.valueChanges.subscribe((value) => {
      this.getFormValidationErrors(dependent);
    });
    this.getTel = this.utilsService.getPhoneNumberWithDashes(dependent.phone|| '');
    dependent.initialFormValues = JSON.parse(JSON.stringify(dependent.form.value));
    dependent.form.get('firstName').valueChanges.subscribe((value: any) => {
      if (value) {
        dependent.firstName = value;
      }
      this.dependents = this.dependents.slice();
    });
    this.formEvent.emit(dependent.form);
    setTimeout(() => {
      this.resetFormDirty(dependent);
    }, 250);
  }

  resetFormDirty(dependent): void {
    dependent.form.reset(dependent.form.getRawValue()); // reset dirty/touched/pending
  }

  ngOnInit(): void {
    this.usersInsuranceService.getInsurancePrimary(this.usersService.getCurrentUserId(), this.vendorProductId()).then(result => {
      this.hasPrimary = !!result.id;
    });
    this.usersInsuranceService.usersInsuranceObservable.subscribe(_ => {
      this.hasPrimary = true;
    });
    this.usersInsuranceService.getInsuranceDependents(this.usersService.getCurrentUserId(), this.vendorProductId()).then(result => {
      this.dependents = result;
      result.forEach((dependent: any) => this.buildForm(dependent));
    });
  }

  ngAfterViewInit(): void {
    this.setTabClass();
    this.tabGroup.selectedIndex = 0;
  }

  getFormValidationErrors(dependent): void {
    const messages = [];
    console.log('CONTROLS', dependent.form.controls)
    Object.keys(dependent.form.controls).forEach(key => {
      const controlErrors: ValidationErrors = dependent.form.get(key)?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach(keyError => {
          let message = '';
          switch (keyError) {
            case 'required':
              message = `${key} is required`;
              break;
            case 'min':
              message = `${key} must be at least ${controlErrors[keyError].min}`;
              break;
            case 'max':
              message = `${key} must be at most ${controlErrors[keyError].max}`;
              break;
            default:
              // message = `${key} is invalid (${keyError})`;
          }
          if (message) {
            messages.push(message);
          }
        });
      }
    });
    dependent.errorMessages = messages.join(', ');
  }

  onTabChanged(event): void {
    this.setTabClass();
    this.currentDependent = this.dependents[this.tabGroup.selectedIndex];
  }

  setTabClass(): void {
    const elements = document.querySelectorAll('.mat-tab-label');
    elements.forEach(function(element) {
      if (element instanceof HTMLElement) {
        element.style.opacity = '1';
      }
    });
  }

  setVal(beneficiary: any, value: any, frmControlName: string) {
    beneficiary.form.get(frmControlName).setValue(value);
    beneficiary.form.get(frmControlName).markAsDirty();
  }

  addDependent() {
    this.dependents.unshift({firstName: ``});
    this.buildForm(this.dependents[0]);
    this.tabGroup.selectedIndex = 1;
    this.currentDependent = this.dependents[0];
    setTimeout(() => {
      this.tabGroup.selectedIndex = 0;
    }, 50);
  }

  resetClicked(dependent: any): void {
    dependent.form.reset();
    // tslint:disable-next-line:forin
    for (const field in dependent.initialFormValues) {
      dependent.form.get(field).setValue(dependent.initialFormValues[field]);
    }
  }

  saveClicked(dependent: any): void {
    const newInfo = {
      gender: dependent.form.get('gender')?.value,
      tobaccoUseDate: this.utilsService.convertDate(dependent.form.get('tobaccoUseDate')?.value),
      firstName: dependent.form.get('firstName')?.value,
      lastName: dependent.form.get('lastName')?.value,
      dob: this.utilsService.convertDate(dependent.form.get('dob')?.value),
      relationship: dependent.form.get('relationship')?.value,
      ssn: dependent.form.get('ssn')?.value,
      email: dependent.form.get('email')?.value,
      phone: dependent.form.get('phone')?.value.replace('-', '')
    };
    this.saving = true;
    if (dependent.id && !this.dependents[0].fromWallit) {
      this.usersInsuranceService.modifyInsuranceDependent(this.usersService.getCurrentUserId(), dependent.id, newInfo).then(_ => {
        this.saving = false;
        this.usersInsuranceService.updateCarriers(this.usersService.getCurrentUserId());
        this.resetFormDirty(dependent);
        this.toastComponent.presentToast('User insurance dependent info updated');
      });
    } else {
      this.usersInsuranceService.createInsuranceDependent(
          this.usersService.getCurrentUserId(),
          this.vendorProductId(),
          dependent.form.get('gender')?.value,
          {},
          this.utilsService.convertDate(dependent.form.get('tobaccoUseDate')?.value),
          dependent.form.get('firstName')?.value,
          dependent.form.get('lastName')?.value,
          this.utilsService.convertDate(dependent.form.get('dob')?.value),
          dependent.form.get('relationship')?.value,
          dependent.form.get('ssn')?.value,
          dependent.form.get('email')?.value,
          dependent.form.get('phone')?.value.replace('-', '')
      ).then(result => {
        this.saving = false;
        dependent = Object.assign({}, dependent, newInfo);
        this.currentDependent.id = result.id;
        this.toastComponent.presentToast('User insurance dependent info created');
        this.dependents = this.dependents.slice();
        this.resetFormDirty(dependent);
      });
    }
  }

  removeClicked(dependent: any): void {
    if (dependent.id) {
      this.uiAlertService.presentAlertConfirm('Do you really want to remove this dependent?').then(ok => {
        if (ok) {
          this.usersInsuranceService.deleteInsuranceDependent(this.usersService.getCurrentUserId(), dependent.id).then(_ => {
            this.usersInsuranceService.updateCarriers(this.usersService.getCurrentUserId());
            this.toastComponent.presentToast('Dependent removed');
            this.dependents.splice(this.dependents.findIndex((item: { id: string; }) => item.id === dependent.id), 1);
            this.dependents = this.dependents.slice();
          });
        }
      });
    } else {
      this.toastComponent.presentToast('Dependent removed');
      this.dependents.splice(this.tabGroup.selectedIndex, 1);
      this.dependents = this.dependents.slice();
    }
  }

  vendorProductId() {
    // return this.vendorProduct?.id || 'wallit';
    return 'wallit';
  }

}
